<template>
    <div>
        <el-form ref="ruleForm" :inline="true" class="query-form" size="mini" :model="query" :rules="rules">
            <el-form-item label="国家：" class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    clearable
                    @change="getList"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告组合名称" min-width="80" align="center">
                <el-input
                    v-model="query.ad_portfolio_name"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入广告组合名称"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                <el-button type="success" icon="el-icon-plus" @click="uploadFile">上传文件</el-button>
                <el-button type="success" @click="uploadFileList">上传文件列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            :height="tableHeight"
            @sort-change="handleSortChange"
            border
            style="width: 100%"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="国家" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Asin" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column>

            <el-table-column label="广告组合名称" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_portfolio_name || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" min-width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="解析时间" min-width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.parsing_time || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="记录最早时间" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.excel_begin_date || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="记录最晚时间" min-width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.excel_end_date || '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" min-width="150" align="center">
                <template slot-scope="scope">
<!--                    <el-button v-if="scope.row.status == '1'" size="mini" style="margin: 5px 0 5px 10px">上传中</el-button>-->
<!--                    <el-button type="success" v-if="scope.row.status == '2'" size="mini" style="margin: 5px 0 5px 10px">-->
<!--                        上传完成-->
<!--                    </el-button>-->
<!--                    <el-button type="danger" v-if="scope.row.status == '-1'" size="mini" style="margin: 5px 0 5px 10px">-->
<!--                        上传失败-->
<!--                    </el-button>-->
<!--                    <el-button type="danger" @click="showErrorInfo(scope.row)" v-if="scope.row.status == '-1'"-->
<!--                               size="mini" style="margin: 5px 0 5px 10px">查看失败原因-->
<!--                    </el-button>-->
                    <el-button style="margin: 5px 0 5px 10px" type="success"
                               @click="downFile(scope.row.parsing_path)" size="mini">导出
                    </el-button>
                </template>
            </el-table-column>

            <!--            <el-table-column label="操作" width="90" fixed="right">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <el-button-->
            <!--                        style="margin: 5px 0 5px 10px"-->
            <!--                        type="danger"-->
            <!--                        size="mini"-->
            <!--                        @click="delete_records(scope.row)"-->
            <!--                    >删除-->
            <!--                    </el-button-->
            <!--                    >-->
            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <add
            :visible="ctrl.addDialogVisible"
            :us_arr="us_arr"
            :title="'上传文件'"
            @close-callback="closeCllback"
            @error-dialog="errorDialog"
        ></add>

        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow">
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
        <upload-file-list-dialog :visible="this.ctrl.uploadFileListVisible" title="上传SD种子词数据列表"
                                 @close-callback="closeCllback"></upload-file-list-dialog>
    </div>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import Add from './add'
    import {downloadFileUrl} from '@/utils/method'
    import * as etymaApi from '@/api/etyma/etyma.js'
    import uploadFileListDialog from './uploadFileListDialog'

    export default {
        components: {Add, uploadFileListDialog},
        data() {
            return {
                errorInfoShow: false,
                ctrl: {
                    addDialogVisible: false,
                    uploadFileListVisible: false,
                    addMonthDialogVisible: false,
                    charts_keywordVisible: false,
                    charts_keywordMonthVisible: false,
                    uploadDialogVisible: false,
                    upload1DialogVisible: false,
                    errorVisible: false,
                },
                tableHeight: null,
                formData: {},
                query: {
                    page: 1,
                    limit: 10,
                    state: '',
                    asgin: '',
                    ad_portfolio_name: '',
                    type: '',
                },
                rules: {
                    asin: [
                        {
                            required: true,
                            message: '请输入ASIN',
                            trigger: 'blur'
                        }
                    ],
                    state: [
                        {
                            required: false,
                            message: '请输入国家',
                            trigger: 'blur'
                        }
                    ],
                    ad_portfolio_name: [
                        {
                            required: true,
                            message: '请输入广告组合名称',
                            trigger: 'blur'
                        }
                    ],
                    type: [
                        {
                            required: true,
                            message: '请选择广告组类型',
                            trigger: 'blur'
                        }
                    ]
                },
                us_arr: [
                    {
                        us: 'US',
                        title: '美国'
                    },
                    {
                        us: 'UK',
                        title: '英国'
                    },
                    {
                        us: 'DE',
                        title: '德国'
                    }
                ],
                list: [],
                listData: [],
                requestCount: 0,
                charts_keyword: '',
                country_code_str: '',
                loadingkeyword_tracker: false,
                disabled: false,
                loading: false
            }
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.ruleForm.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                        if (typeof that.$refs.ruleForm == 'object') {
                            that.tableHeight = window.innerHeight - 140 - that.$refs.ruleForm.$el.offsetHeight
                        }
                    }
                )()
            }
            this.getList()
        },
        methods: {
            uploadFileList() {
                this.ctrl.uploadFileListVisible = true
            },
            uploadFile() {
                this.ctrl.addDialogVisible = true
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.err_smg
            },

            searchForm() {
                this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({type: 'error', message: '无法下载！'})
                }
                downloadFileUrl(path)
            },
            getList() {
                this.$refs['ruleForm'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.sd_ad_lastest_campaign_update_list(this.query).then(res => {
                            if (res.code === 0) {
                                this.list = res.data.list
                                this.query.total = res.data.total
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                            }
                            this.loading = false
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },

            change() {
                this.getList()
            },
            handleSortChange(val) {
                let obj = {}
                if (val.order == 'ascending') {
                    obj.desc = 0
                    obj.field = val.prop
                } else if (val.order == 'descending') {
                    obj.desc = 1
                    obj.field = val.prop
                }
                this.query.order = obj
                this.getList()
            },
            exportData() {
                this.ctrl.upload1DialogVisible = true
            },
            latelyExportData() {
                this.ctrl.uploadDialogVisible = true
            },
            //错误内容
            errorPageDialog() {
                this.ctrl.errorVisible = true
            },
            //错误页面
            errorDialog(data) {
                let that = this
                this.listData = data.data
                setTimeout(function () {
                    that.errorPageDialog()
                }, 10)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //重置
            onReset() {
                this.$refs["ruleForm"].resetFields();
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            //查询
            onSubmit() {
                this.getList()
            },
            // 关闭弹窗回调
            closeCllback(isshow) {
                this.ctrl.addDialogVisible = false
                this.ctrl.uploadFileListVisible = false
                if (isshow) return
                this.getList()
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #fff !important;
    }

    /deep/ .el-button--mini {
        padding: 5px 5px !important;
    }

    .pen:hover {
        cursor: pointer;
        text-decoration: underline;
    }
</style>
